import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11 0C4.92 0 0 4.92 0 11s4.92 11 11 11 11-4.92 11-11S17.08 0 11 0m0 20.31c-5.14 0-9.31-4.17-9.31-9.31S5.86 1.69 11 1.69s9.31 4.17 9.31 9.31-4.17 9.31-9.31 9.31"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.96 5.23c-1.59.05-3.18 1.09-3.55 2.82-.09.45.23.96.73 1.05s.96-.23 1.09-.73c.14-.68.91-1.32 1.77-1.32 0 0 1.69-.13 1.73 1.55 0 .41-.27.77-.86 1.27-.09.05-.73.59-.96.86-.27.32-.64.82-.64 1.46 0 .5.41.91.91.91s.61-.51.91-.91c.06-.08.82-.86.91-.91.59-.5 1.59-1.36 1.59-2.73 0-1.96-1.68-3.46-3.64-3.32Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "11.15",
  cy: "15.63",
  r: "1.15",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }